
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { getOptimizedImage } from '~/helpers/getOptimizedImage';

export default defineComponent({
  name: 'ParticularsSection',
  props: {
    title: {
      type: [String, Object],
      default: null,
    },
    features: {
      type: Array,
      default: () => [],
    },
    link: {
      type: Object,
      default: () => ({}),
    },
    modal: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const modalRef = ref();

    const openModal = () => {
      modalRef.value.open();
    };

    return {
      modalRef,
      getOptimizedImage,
      openModal,
    };
  },
});
